export const fetchEventBulbblePath = (event) => {
    var path: HTMLElement[] = [];
    var node = event.target;
    if (event instanceof Event) {
        path = event.composedPath && event.composedPath() as HTMLElement[];
        if (path && path.length > 0) {
            return path;
        }
    }
    while (node != document.body && node) {
        path.push(node);
        node = node.parentNode;
    }
    return path;
}